module.exports = __webpack_public_path__ + "img/kingdom-waiting.5bb20ed5.png";